.rowSelected {
  background-color: var(--mantine-color-blue-light);
}

.badgeLabel { 
  text-overflow: unset;
  overflow: visible;
}